<template>
  <v-app title="TeamBot">
    <!--                    Remember Me-->
    <router-view></router-view>
    <LoadingScreen :show="loading" />
    <snackbar :color="snackColor" :snackbar="snackShow" :text="snackText" />
  </v-app>
</template>

<script lang="ts">
import LoadingScreen from './components/LoadingScreen'
import snackbar from './components/snackbar'
import { bus } from './main.js'

export default {
  name: 'TeamBot',
  metaInfo: {
    title: 'TeamBot',
    titleTemplate: s => (s === 'TeamBot' ? 'TeamBot' : `${s} | TeamBot`)
  },
  components: {
    LoadingScreen,
    snackbar
  },
  data () {
    return {
      snackText: '',
      snackColor: 'error',
      snackShow: false,
      loading: false
    }
  },
  mounted () {
    this.setupGlobalEventListeners()
  },
  methods: {
    setupGlobalEventListeners () {
      bus.$on('loading-on', text => {
        this.loading = true
      })
      bus.$on('loading-off', () => {
        this.loading = false
      })
      bus.$on('error', text => {
        this.snackbarOn(text, 'error darken-1')
      })
      bus.$on('success', text => {
        this.snackbarOn(text, 'secondary')
      })
    },
    snackbarOn (text, color) {
      this.snackColor = color
      this.snackText = text
      this.snackShow = true
      setTimeout(() => {
        this.snackShow = false
      }, 5000)
    }
  }
}
</script>
<style>
.theme--light.v-application {
  background-image: linear-gradient(to right, #152634, #17303f) !important;
}
body {
  font-family: Poppins, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.4;
}
.order-xs-1 {
  order: 1;
}
.flex-xs-column {
  flex-direction: column;
}
@media (min-width: 960px) {
  body {
    overflow: hidden;
  }
}
@media (max-width: 960px) {
  body {
    overflow-x: hidden;
  }
  .background-gradient {
    position: absolute;
    height: 122% !important;
    width: 100%;
    top: -100px;
    transform: rotate(5deg) !important;
    z-index: 2;
  }
  .paned-view__left {
    order: 1;
    height: 25%;
  }
  .paned-view__right {
    min-height: 75%;
    margin-left: 9px;
    padding-left: 34px !important;
    padding-right: 30px !important;
  }
  .img {
    position: absolute;
    height: auto;
    width: auto;
    max-height: 100%;
    min-width: 100%;
    z-index: 0;
    margin-top: -12px;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: hidden;
  }
  .bg-overlay {
    opacity: 0.4;
  }
  ._title {
    display: flex;
    justify-content: center;
    font-size: 38px !important;
    font-weight: 800 !important;
    margin: 50px 0px !important;
    text-align: center;
  }
  .tb-input {
    height: 60px !important;
  }
  .tb-primary-btn {
    height: 50px !important;
    width: 100% !important;
    font-size: 15px;
    background-color: #213343;
    transition: 0.1s ease-in-out;
    border-radius: 7px !important;
  }
  .login-btn-container {
    margin-top: 5px !important;
  }
}

._title {
  font-family: Poppins, Helvetica, Arial, sans-serif !important;
  font-size: 38px;
  font-weight: 500;
  color: white;
}
._subtitle {
  margin-top: 2px;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.5);
}

.tb-input {
  height: 70px;
  min-width: 100%;
  font-size: 15px;
  background-color: #213343;
  padding: 18px;
  transition: 0.1s ease-in-out;
  border-radius: 7px !important;
  color: white;
}
.tb-input:focus {
  background-color: white;
  color: black;
  outline: none;
  transition: 0.1s ease-in-out;
}
.tb-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}
.tb-input:focus::placeholder {
  color: rgba(0, 0, 0, 0.75);
}

.tb-primary-btn {
  color: white;
  position: relative;
  width: 200px;
  height: 40px;
  background-color: #07cb69;
  font-size: 18px;
  border-radius: 20px 20px 20px 20px;
  filter: drop-shadow(0px 3px 5px rgba(7, 203, 105, 0.6));
}
.tb-primary-btn:focus {
  outline: none !important;
}

.tb-primary-btn-full-width {
  height: 50px !important;
  width: 100% !important;
  border-radius: 7px !important;
}
</style>
